import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { PageDto } from '../../../core/dto/page';
import { pluck } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { MetadataService } from '../../../core/services/metadata.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'isav-pages-view-page',
    templateUrl: './pages-view-page.html',
    styleUrls: ['./pages-view-page.sass'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PagesViewPage implements OnInit {
    readonly page$: Observable<PageDto> = this.route.data.pipe(
        pluck('page'),
        this.metaService.seo('title')
    );

    hiddenAttachments: boolean = true;

    constructor(
        private route: ActivatedRoute,
        private metaService: MetadataService
    ) {}

    ngOnInit() {
        // hide attachments while switching pages from footer
        this.route.queryParams.pipe(untilDestroyed(this)).subscribe(() => {
            this.hiddenAttachments = true;
        });
    }
}
